export default __webpack_public_path__ + "static/media/18.93f437c9.jpeg";